<div class="content-login">
  <app-form-recover-password></app-form-recover-password>
</div>